module.exports = __webpack_public_path__ + "img/video-26.e6e46f76.png";